import { BaseMessageResponse } from '@ptl/xhr';
import { ProviderLookupResponsePayload } from './payload/payload.interface';

export interface ProviderLookupResponse {
  baseMessage: BaseMessageResponse;
  payload: ProviderLookupResponsePayload;
}
export interface Locations {
  city: string;
  contract_id: number;
  id: number;
  state: string;
}
export interface Providers {
  href: string;
  id: number
  locations:Locations[]
  locations_count: number
  name: string;
  primary_field_specialty: any
  provider_id: string;
  specialty: string;
  type: string;
}
export interface ProviderLookupAutoCompleteResponse {
  _meta: any;
  providers: Providers[];
  telehealth: any;
  search_specialies: any;
  pharmacy: any;
  procedures: any[];
}

export const DOCTOR_CONTENT_OVERRIDE_NAME = 'doctorSearch';
export interface DoctorContentOverride {
  queryParams?: string;
}